export const UPLOAD_DOCUMENT_FILE_KEY = 'UPLOAD_DOCUMENT_FILE_KEY';
